<template>
    <div class="error-page">
        <div class="error-page-wrapper">
            <div>พบข้อผิดพลาดกรุณาลองใหม่อีกครั้ง</div>
            <div class="error-message">An error occurred. Please try again later.</div>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'


export default {
    name: "home",
    components: {
    },
    data: function() {
        return {

        };
    },
    created: function() {
       setTimeout(() => {

           this.$router.push("/linelogin");
       }, 2000);

    },
    methods: {

    },
};
</script>
<style lang="scss" scoped>
    .error-page {
        min-height: 100vh;
        color: white;
        display: flex;

        .error-page-wrapper {
            margin: auto;
            text-align: center;
            font-size: 0.8rem;

            .error-message {
                margin-top: 10px;
                font-size: 0.7rem;
            }
        }
    }
</style>
